export default __webpack_public_path__ + "static/media/brand.edcdf8d9.svg";